var _g, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRtFailIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 45C0 20.1472 20.1472 0 45 0C69.8528 0 90 20.1472 90 45C90 69.8528 69.8528 90 45 90C20.1472 90 0 69.8528 0 45Z",
    fill: "#FF8F7D",
    fillOpacity: 0.2
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 69,
    height: 69,
    rx: 34.5,
    fill: "#FF8F7D",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64 44.5C64 55.5457 55.0457 64.5 44 64.5C32.9543 64.5 24 55.5457 24 44.5C24 33.4543 32.9543 24.5 44 24.5C55.0457 24.5 64 33.4543 64 44.5ZM50.7175 51.2174C50.1318 51.8032 49.182 51.8032 48.5962 51.2174L44 46.6212L39.4038 51.2174C38.818 51.8032 37.8683 51.8032 37.2825 51.2174C36.6967 50.6316 36.6967 49.6819 37.2825 49.0961L41.8787 44.4999L37.2825 39.9037C36.6967 39.3179 36.6967 38.3682 37.2825 37.7824C37.8683 37.1966 38.818 37.1966 39.4038 37.7824L44 42.3786L48.5962 37.7824C49.182 37.1966 50.1317 37.1966 50.7175 37.7824C51.3033 38.3682 51.3033 39.3179 50.7175 39.9037L46.1213 44.4999L50.7175 49.0961C51.3033 49.6819 51.3033 50.6316 50.7175 51.2174Z",
    fill: "#F46C57"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRtFailIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/RT_fail_icon.da857e59f96277da50ba2c1c1f3f8d4b.svg";